import { useCallback, useRef } from 'react';
import { useIntersection } from '@mantine/hooks';

interface IntersectionObserverProps {
    root?: Element | null;
    rootMargin?: string;
    threshold?: number | number[];
}

const useViewport = (options?: IntersectionObserverProps) => {
    const { root, rootMargin, threshold } = options ?? {};
    const viewport = useRef<HTMLDivElement>(null);
    const { ref, entry } = useIntersection({
        root: root ?? viewport.current,
        rootMargin: rootMargin ?? '0px',
        threshold: threshold ?? 1
    });

    const scrollToBottom = useCallback(() => {
        viewport.current?.scrollTo({
            top: viewport.current.scrollHeight
        });
    }, [viewport]);

    const scrollToTop = useCallback(() => {
        viewport.current?.scrollTo({
            top: 0
        });
    }, [viewport]);

    return {
        viewport,
        ref,
        isIntersecting: !!entry?.isIntersecting,
        scrollToBottom,
        scrollToTop
    };
};

export default useViewport;
